<template>
  <trainer3 @success="success"/>
</template>
<script>
import trainer3 from '@/views/lesson2/components/trainer3/trainer3'

export default {
  name: 'trainer1',
  components: { trainer3 },
  methods: {
    success() {
      this.$emit('success')
    },
  },
}
</script>
